import { OnInit, Component, EventEmitter, Output, Input } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DependenciaJefesModel } from 'src/app/models/dependencia-jefes.model';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';

@Component({
    selector: 'app-informacion-jefe-component',
    templateUrl: './informacion-jefe.component.html',
    styleUrls: ['./../administrar-funcionarios.component.scss']
})
export class InformacionJefeComponent implements OnInit {

    @Input() datosFuncionario: AdministrarFuncionarioDTO;
    @Input() existeFuncionario: boolean;
    @Input() deshabilitado: boolean;
    @Input() dominios: DetalleDominio[];
    public rolUsuario: string;
    public consultaDependencia: any;
    public listaDependencias: any;
    public consultaInstalacion: any;
    public dependencia: any;

    constructor(
        private utilService: UtilService,
        private spinner: NgxSpinnerService,
        private global: GlobalService,
        private urlService: UrlService,
        private alertService: AlertService) {
            this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
            this.consultaDependencia = [];
            this.consultaInstalacion = [];
    }

    ngOnInit() {
        this.obtenerDependencia();
        this.obtenerInstalacion();
        this.obtenerJefe();
    }

    /**
     * Metodo que realiza la consulta de las instalaciones
     */
    public obtenerInstalacion() {
        this.consultaInstalacion = this.dominios.filter(dominio =>
            dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_SEDE);
    }

    /**
     * Metodo que realiza la consulta de las dependencias
     */
    public obtenerDependencia() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDependencias';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
         this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.consultaDependencia = data;
                if (this.datosFuncionario.dependencia) {
                    this.listaDependencias = data;
                    this.dependencia = this.datosFuncionario.dependencia;
                }
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las dependencias');
            }
        );
    }

    obtenerJefe() {

        if (this.utilService.validarCamposObligatorios(this.dependencia)
            && this.utilService.validarCamposObligatorios(this.datosFuncionario.instalacion)) {
            const dependencia = this.consultaDependencia.filter(dep => dep.idDependencia.toString() ===
                this.dependencia && dep.sede === this.datosFuncionario.instalacion);
            if (dependencia.length > 0) {
                this.datosFuncionario.nombreDependencia = dependencia[0].nombreDependencia;
                this.datosFuncionario.dependencia = dependencia[0].idDependencia;
                this.consultarJefe();
            }
        }
    }

    /**
     * Metodo que consulta el jefe al que pertenece dicha dependencia y instalacion
     */
    consultarJefe() {
        this.spinner.show();
        const serviceProvider = 'obtenerJefe';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['nombreDependencia', this.datosFuncionario.nombreDependencia]);
        queryParams.push(['sede', this.datosFuncionario.instalacion]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
         this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            (data: DependenciaJefesModel[]) => {
                if (data.length > 0) {
                    this.datosFuncionario.jefeArea = data[0].nombreCompletoJefe;
                }
                this.spinner.hide();
            }, err => {
                this.cathException('Se presentó un error al obtener al jefe de área');
            }
        );
    }

    /**
     * Metodo que filtra las dependencias por sede
     * @author klagos@asesoftware.com
     */
    filtrarDependencias() {
        this.listaDependencias = this.consultaDependencia.filter(dep => dep.sede ===
            this.datosFuncionario.instalacion);
        this.dependencia = undefined;
        this.datosFuncionario.jefeArea = undefined;
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
